import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const BulkUpdateStationsWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-update-stations-drawer",
  },
)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-inline-end: 48px;
`;
